import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const PaperPlaneIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="67"
			height="71"
			viewBox="0 0 67 71"
			fill="none"
			{...props}
		>
			<path
				d="M66.437 0C43.7107 2.82365 22.4255 11.7834 0.0206209 16.0866C-0.0391502 16.4877 0.0272777 16.7082 0.269019 17.0296C0.543966 17.3935 3.14465 18.9992 3.76228 19.3817C5.75997 20.6182 12.8595 23.5415 13.683 24.867C14.6858 26.4793 16.0752 32.6752 16.6808 34.8866C17.5987 38.2362 18.4036 41.6455 19.1487 45.0376C19.611 45.1027 19.7345 45.0549 20.0692 44.7627C20.9073 44.0295 22.7257 41 23.6714 39.8645C24.1509 39.2881 27.4795 35.5214 27.7783 35.5188C30.731 37.5083 33.709 39.8804 36.8675 41.53C37.4081 41.8116 38.7789 42.6841 39.3049 42.3481C46.4801 30.1955 56.4207 19.8904 63.2904 7.49611C63.8562 6.47609 66.6455 1.45966 66.6973 0.788946C66.7239 0.44894 66.7345 0.224458 66.437 0ZM11.0079 21.965C9.73146 21.3301 8.16944 20.8666 6.91557 20.2132C6.28333 19.8838 2.01565 17.2766 1.88283 17.0096C1.62249 16.4903 2.31055 16.6351 2.50713 16.582C7.58634 15.202 12.7851 14.1926 17.8763 12.8206C32.8297 8.78838 47.5506 3.56743 62.9782 1.47692L59.4398 3.38017C44.3031 9.65701 29.0216 15.7997 14.9196 24.1989C13.5501 23.5481 12.3853 22.6516 11.0079 21.965ZM19.6455 39.559C19.591 39.9614 19.5166 41.1607 19.15 41.3175L14.9169 25.1392C29.9035 16.493 45.966 9.97974 61.9169 3.33633C54.9569 8.9584 46.8838 13.0172 39.3593 17.8318C33.1843 21.783 27.2338 26.0995 21.1172 30.1398C20.2658 31.2089 19.8872 37.774 19.6455 39.559ZM20.2126 42.6469L21.5396 31.2262L26.8499 34.682L20.2126 42.6469ZM38.8108 41.2072C38.3591 41.5007 35.085 39.3492 34.4169 38.9334C30.4242 36.4551 26.4846 33.5132 22.7191 30.6936C22.4109 30.2181 22.8691 30.0388 23.152 29.7825C25.7673 27.4276 31.6847 23.9891 34.8951 21.868C41.8259 17.2899 48.9453 13.0584 56.0501 8.75652L64.8391 2.53944C57.9348 16.5953 46.9981 27.9735 38.8108 41.2072Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M33.5242 63.6608L34.5536 66.2852C34.1113 66.77 32.7658 64.4325 32.439 64.2943C31.9569 64.0858 29.7254 65.5959 29.5089 64.556C29.3043 63.5732 32.354 64.0911 31.9051 62.5691L32.5652 62.5611L32.8228 63.1003L34.948 62.0352C36.0319 62.771 33.6357 63.4696 33.5242 63.6595V63.6608Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M54.7429 66.8197C54.8266 67.4187 54.7548 67.5051 54.3099 67.8451C54.0296 68.0589 50.8126 69.654 50.5709 69.6912C50.2494 69.7404 49.6969 69.6354 49.7022 69.3419C49.7102 68.9421 54.4613 66.5382 54.7429 66.8197Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M38.9383 57.7923C39.2916 58.0752 39.4059 58.1842 39.2863 58.6596C39.1455 59.2201 36.4572 62.1248 36.0202 62.0345C35.7306 61.976 35.5592 61.5962 35.7452 61.2349C36.1981 60.3583 38.4097 58.9492 38.9383 57.791V57.7923Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M49.1646 69.4756C49.3093 70.9259 44.0508 71.0123 43.8516 70.8011V70.0068L49.1646 69.4756Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M58.3346 63.1006L58.9947 63.7593L55.6727 66.8114L55.4031 66.0172L58.3346 63.1006Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M33.2255 53.2725C33.4805 54.2832 32.6065 54.6431 32.2824 55.3816C32.0739 55.8571 31.4629 58.0445 31.2344 58.0472C29.784 57.2822 32.6902 52.6602 33.2255 53.2725Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M19.9457 60.4443L23.9278 63.4938C23.4988 64.0768 23.5041 63.7886 23.0445 63.5881C22.4535 63.3304 19.2909 61.1761 19.9457 60.4443Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M34.0237 53.2696L34.1791 52.4502C34.7914 51.9999 38.0988 52.1274 38.2728 52.8752C38.0589 54.1143 37.0016 53.0651 36.2512 53.012C35.5073 52.9588 34.7874 53.4051 34.0237 53.2683V53.2696Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M28.7134 64.1636V64.9578C28.0148 65.1398 24.2598 64.8755 24.463 63.7678C24.5773 63.1436 25.1445 63.6045 25.3716 63.647C26.4807 63.8542 27.5539 64.2752 28.7134 64.1636Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M19.6773 59.9095C18.7954 60.7449 16.8973 56.4099 17.2891 55.6621L18.0967 56.3129L19.6773 59.9095Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M39.4762 68.9414C40.0221 69.5178 43.2325 69.5603 43.0558 70.3997C42.8765 71.2511 39.1933 70.1328 39.0737 69.6042L39.4775 68.9427L39.4762 68.9414Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M17.8178 50.8809C17.8656 51.5622 17.5694 52.1877 17.5402 52.8625C17.503 53.6886 18.1007 55.0526 17.1603 55.1283C16.4205 54.9755 16.7844 51.7256 17.0195 51.0562L17.8191 50.8809H17.8178Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M59.2616 62.8326C58.7781 62.3412 61.687 59.58 62.0456 59.6477C62.4653 59.7274 62.4082 59.9691 62.1837 60.3105C61.9234 60.7062 59.7305 63.3094 59.2616 62.8326Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M35.4835 66.5586L38.5345 68.8098C38.5929 69.863 36.129 68.1816 35.9072 67.989C35.4025 67.5494 34.6454 67.1656 35.4835 66.5586Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M38.9423 53.8032C39.8336 53.6451 40.6597 57.0611 39.7313 57.2537C38.682 57.1368 39.374 56.3692 39.2797 55.8565C39.2013 55.4368 38.241 53.928 38.9423 53.8032Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M18.2987 50.0209C16.645 50.9772 18.1858 47.4111 19.5419 47.6926C19.9656 47.7803 19.9045 48.0154 19.68 48.3567C19.5831 48.5055 18.3916 49.9664 18.2973 50.0209H18.2987Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M31.3699 61.7698C31.2756 60.7777 30.2953 59.4296 31.2344 58.5889L32.1256 61.3461L31.3699 61.7698Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M42.0568 25.7142C41.1988 23.5692 37.9286 24.6291 37.74 26.7076C36.5433 25.4751 34.7927 24.6543 33.6358 26.4527C31.9276 29.109 35.1101 33.7309 37.5807 34.9329C39.3605 32.6471 43.3213 28.8765 42.0568 25.7142ZM41.3369 28.3107C40.8189 30.3149 38.5862 32.0003 37.7135 33.8584C35.4024 33.6247 32.4138 27.5457 34.8857 26.373C36.1807 25.758 37.3243 27.037 37.2128 28.3041H38.0044C38.1903 24.7672 42.5523 23.6064 41.3369 28.3107Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
		</svg>
	);
};

export default memo(PaperPlaneIcon);
